<template>
  <v-container fluid>
    <v-row justify="start" class="ma-2" no-gutters>
      <v-col cols="12">
        <h1>{{ $t("collections.title") }}</h1>
      </v-col>

      <!-- Buttons -->
      <v-col cols="12" class="mt-6 text-right">
        <v-btn color="primary" @click="setShowAddDialog(true)">
          {{ $t("collections.buttons.add") }}
        </v-btn>
      </v-col>

      <v-col cols="12" class="mt-6">
        <div>
          <v-text-field
            v-model="search"
            append-icon="fas fa-search"
            :label="$t('common.inputs.search')"
            clearable
            v-on:click:clear="clearInput"
            @keyup.enter.native="searchTrigger"
            outlined
          ></v-text-field>
        </div>
      </v-col>

      <!-- Table -->
      <v-col cols="12" class="mt-2">
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="totalItems"
          :options.sync="pagination"
          :loading="loading"
          :items-per-page="20"
          style="min-height: 600px"
          multi-sort
          sort-by="name"
          :sort-desc="false"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          class="elevation-1"
        >
          <!-- Picture -->
          <template v-slot:item.picture="{ item }">
            <DisplayPicture
              :custom-width="50"
              :img="item.picture"
              :name="item.name"
            />
          </template>

          <!-- Name -->
          <template v-slot:item.name="{ item }">
            <router-link :to="{ name: 'Collection', params: { id: item.id } }">
              {{ item.name }}
            </router-link>
          </template>

          <!-- Brand -->
          <template v-slot:item.account="{ item }">
            <AccountLink :account="item.account" />
          </template>

          <!-- Year -->
          <template v-slot:item.year="{ item }">
            {{ item.year }}
          </template>

          <!-- Nb Products -->
          <template v-slot:item.nb_products="{ item }">
            {{ item.nb_products }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Main brand dialog -->
    <CollectionMainDialog
      v-if="showDialog.add"
      :value="showDialog.add"
      :item="null"
      @close="(needRefresh) => setShowAddDialog(false, needRefresh)"
    />
  </v-container>
</template>

<script>
import vuetifyDatatable from "@/mixins/vuetifyDataTable";
import formatter from "@/mixins/formatter";

export default {
  name: "CollectionsView",

  components: {
    AccountLink: () => import("@/components/Common/Accounts/AccountLink"),
    DisplayPicture: () => import("@/components/Common/Picture/DisplayPicture"),
    CollectionMainDialog: () =>
      import("@/components/Collections/CollectionMainDialog"),
  },

  mixins: [vuetifyDatatable, formatter],

  data() {
    return {
      headers: [
        {
          text: "",
          value: "picture",
          sortable: false,
        },
        {
          text: this.$t("collections.datatable.headers.name"),
          value: "name",
          sortable: true,
          width: "40%",
        },
        {
          text: this.$t("collections.datatable.headers.brand"),
          value: "account",
          sortable: false,
          width: "40%",
        },
        {
          text: this.$t("collections.datatable.headers.year"),
          value: "year",
          sortable: false,
          width: "40%",
        },
        {
          text: this.$t("collections.datatable.headers.nb_products"),
          value: "nb_products",
          sortable: false,
          width: "40%",
        },
      ],
      URL_API: {
        GET_ALL: "/brand-collections",
      },

      showDialog: {
        add: false,
      },
      isLoadingExportBtn: false,
      savePaginationURL: true,
    };
  },

  created() {
    this.$store.commit("pageHead/setTitle", this.$t("collections.pageTitle"));
  },

  methods: {
    setShowAddDialog(val, reloadData = false) {
      if (reloadData) this.searchTrigger();
      this.showDialog.add = val;
    },

    goToOne(obj) {
      this.$router.push({
        name: "Collection",
        params: { id: obj.id },
      });
    },
  },
};
</script>

<style scoped></style>
